import React from 'react';

function MiniSearchItem({ children, dataSeleniumId }) {
    return <li data-seleniumid={dataSeleniumId}>{children}</li>;
}

export default MiniSearchItem;
